
// export const baseURL = 'http://192.168.0.102:8888/'
// export const baseURL = 'http://172.18.0.1:8888/'

const getUrl = window.location;
let baseUrlDin = getUrl .protocol + "//" + getUrl.host + "/";
console.log('getUrl.host', getUrl.host)
if('localhost:3000'===getUrl.host){
    baseUrlDin = 'http://sertelws.local/';
}
// export const baseURL = 'http://sertelws.local/';
// export const baseURL = 'http://191.252.193.207/';
// baseUrlDin = 'http://201.76.162.170:8080/';
export const baseURL = baseUrlDin;